/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import type { UsageCreate } from '../models/UsageCreate';
import type { UsageDetails } from '../models/UsageDetails';
import type { UsageUpdate } from '../models/UsageUpdate';
import { request as __request } from '../core/request';

export class UsagesVService {

    /**
     * @param serviceAddressId
     * @param meterId
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async usagesVGetAll(
        serviceAddressId: string,
        meterId: string,
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/${meterId}/usages/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @param meterId
     * @param requestBody
     * @returns UsageDetails OK
     * @throws ApiError
     */
    public static async usagesVGetExport(
        serviceAddressId: string,
        meterId: string,
        requestBody?: PagingQuery,
    ): Promise<UsageDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/${meterId}/usages/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param usageId
     * @param serviceAddressId
     * @param meterId
     * @param requestBody
     * @returns UsageDetails OK
     * @throws ApiError
     */
    public static async usagesVUpdateUsage(
        usageId: string,
        serviceAddressId: string,
        meterId: string,
        requestBody?: UsageUpdate,
    ): Promise<UsageDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/${meterId}/usages/${usageId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @param meterId
     * @param usageId
     * @returns UsageDetails OK
     * @throws ApiError
     */
    public static async usagesVGetById(
        serviceAddressId: string,
        meterId: string,
        usageId: string,
    ): Promise<UsageDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/${meterId}/usages/${usageId}`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @param meterId
     * @param usageId
     * @returns any OK
     * @throws ApiError
     */
    public static async usagesVDelete(
        serviceAddressId: string,
        meterId: string,
        usageId: string,
    ): Promise<any> {
        const result = await __request({
            method: 'DELETE',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/${meterId}/usages/${usageId}`,
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param serviceAddressId
     * @param meterId
     * @param requestBody
     * @returns UsageDetails Created
     * @throws ApiError
     */
    public static async usagesVCreate(
        serviceAddressId: string,
        meterId: string,
        requestBody?: UsageCreate,
    ): Promise<UsageDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/service_addresses/${serviceAddressId}/meters/${meterId}/usages`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
            },
        });
        return result.body;
    }

}